import { ChannelIdeaEvaluationResult } from '@frontend/data-access';
import useTranslation from 'next-translate/useTranslation';

/* eslint-disable-next-line */
export interface IdeaChannelEvaluationResultTagProps {
  results: ChannelIdeaEvaluationResult[];
}

export function IdeaChannelEvaluationResultTag({
  results,
}: IdeaChannelEvaluationResultTagProps) {
  const { t } = useTranslation('common');

  const average =
    results.reduce((prev, curr) => prev + curr?.score, 0) / results.length;

  const score = isNaN(average) ? null : average.toFixed(1);
  const expertCount = results.reduce(
    (prev, curr) => prev.add(curr?.createdBy?.id),
    new Set<number>([])
  );

  if (score) {
    return (
      <div className="text-xs space-x-2">
        <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded-full w-6 h-6 text-center">
          {score}
        </span>
        {expertCount.size > 0 && (
          <span className="text-gray-700">
            {t('by_people', { count: expertCount.size })}
          </span>
        )}
      </div>
    );
  } else return null;
}

export default IdeaChannelEvaluationResultTag;
